import {forwardRef, InputHTMLAttributes, useCallback, useEffect, useState} from 'react'
import {Dropdown, Modal, OverlayTrigger, Tooltip} from 'react-bootstrap'
import {Navigate, useSearchParams} from 'react-router-dom'
import {useMutation, useQueryClient} from 'react-query'
import {OverviewAttachement} from '../../project/components/tasks-list/TaskAttachment/OverviewAttachment'
import {CKEditor} from '@ckeditor/ckeditor5-react'
import SourceEditingEditor from 'ckeditor5-build-classic-source-editing'
import {ID, KTSVG} from '../../../../_metronic/helpers'
import {UsersSymbolGroupColumn} from '../../project/components/tasks-list/UsersSymbolGroupColumn'
import {Toast} from '../../../../_metronic/partials/widgets'
import {useFormik} from 'formik'
import {useIntl} from 'react-intl'
import {Task} from '../core/_models'
import {taskPriorityOptions} from '../../project/components/tasks-list/core/_models'
import {TaskChecklistEditor} from '../../project/components/tasks-list/TaskChecklist/TaskChecklistEditor'
import Swal from 'sweetalert2'
import {
  addSubtaskTemplate,
  deleteTaskTemplate,
  getAssignableSubtaskTemplates,
  removeSubtaskTemplate,
  updateTaskTemplate,
} from '../core/_requests'
import {CustomToggleProps} from './table/columns/ActionsCell'
// import {TaskSequenceResponsibles} from '../../project/components/tasks-list/task-edit-modal/TaskSequenceResponsibles'
import clsx from 'clsx'
import {TagsAutoComplete} from '../../../../_metronic/partials/modals/task/components/TagsAutoComplete'
import {Loading} from '../../../../_metronic/partials/components/loading/Loading'
import {Attachement} from './Attachment'
import CreatableSelect from 'react-select/creatable'
import AsyncSelect from 'react-select/async'
import {useAuth} from '../../auth'

interface checkProps extends InputHTMLAttributes<HTMLInputElement> {
  content: string
  check: boolean
}

type Props = {
  isTaskLoading: boolean
  task: Task
  handleClose: () => void | undefined
}

type SubtaskSelectOption = {
  value: number
  label: string
  priority?: string | null
}

const SUBTASK_OPTIONS_LIMIT = 20

export const TaskTemplateEditModal = ({task, isTaskLoading, handleClose}: Props) => {
  const [searchParams, setSearchParams] = useSearchParams()
  const intl = useIntl()
  const queryClient = useQueryClient()
  const {auth} = useAuth()
  const TemaAtual = window.localStorage.getItem('kt_theme_mode_value') || ''
  const [checks, setChecks] = useState<Array<checkProps>>([])
  const [selectedOptions, setSelectedOptions] = useState(task!.tags)
  const [selectedSubtask, setSelectedSubtask] = useState<SubtaskSelectOption | null>(null)

  useEffect(() => {
    formik.setFieldValue('id', task.id)
    formik.setFieldValue('name', task.name ?? '')
    formik.setFieldValue('description', task.description?.toString() || '')
    formik.setFieldValue('creator_id', task.creator_id)
    setSelectedSubtask(null)

    setChecks(
      (prev) =>
        task?.checklists?.map((check) => ({content: check.name, check: check.concluded})) ?? []
    )
  }, [task])

  // useEffect(() => {
  //   setChecks(
  //     (prev) =>
  //       task?.checklists?.map((check) => ({content: check.name, check: check.concluded})) ?? []
  //   )
  // }, [task.checklists])

  // useEffect(() => {
  //   if (task.sequence_responsibles) {
  //     formik.setFieldValue('sequence_responsibles', task.sequence_responsibles)
  //     formik.setFieldValue('users', task.sequence_responsibles)
  //   }
  // }, [task.sequence_responsibles])

  const deleta = async () => {
    const CurrentTheme = window.localStorage.getItem('kt_theme_mode_value') || ''
    let tema = ''
    if (CurrentTheme === 'dark') {
      tema = '#353b48'
    } else {
      tema = '#fff'
    }

    const swalWithBootstrapButtons = Swal.mixin({
      customClass: {
        confirmButton: 'btn btn-success',
        cancelButton: 'btn btn-danger',
      },
      buttonsStyling: false,
    })

    swalWithBootstrapButtons
      .fire({
        title: 'Você tem certeza?',
        html: 'Tem certeza de que deseja deletar esse modelo de tarefa?',
        icon: 'warning',
        background: tema,
        showCancelButton: true,
        confirmButtonText: 'Sim, pode excluir',
        cancelButtonText: 'Não, cancele!',
        reverseButtons: true,
      })
      .then(async (result) => {
        if (result.isConfirmed) {
          return await deleteItem.mutateAsync()
        }
      })
  }

  const deleteItem = useMutation(() => deleteTaskTemplate(task.id), {
    onSuccess: (response) => {
      Toast.fire({
        icon: 'success',
        title: intl.formatMessage(
          {id: 'ALERT.LABEL.SUCCESS_TASK_DELETE_ITEM'},
          {item: intl.formatMessage({id: 'TABLE.GENERAL.LABEL.TASK'})}
        ),
        customClass: {
          popup: 'bg-light-success',
          title: 'text-success',
        },
      })

      queryClient.invalidateQueries()
      const params = new URLSearchParams()
      setSearchParams(params)
    },
    onError: (error: any) => {
      Toast.fire({
        icon: 'error',
        title: error.response.data.message,
        customClass: {
          popup: 'bg-light-danger',
          title: 'text-danger',
        },
      })
    },
  })

  const addSubtask = useMutation(
    (subtaskTemplateId: number) => addSubtaskTemplate(task.id as number, subtaskTemplateId),
    {
      onSuccess: () => {
        Toast.fire({
          icon: 'success',
          title: 'Subtarefa vinculada com sucesso!',
          customClass: {
            popup: 'bg-light-success',
            title: 'text-success',
          },
        })
        setSelectedSubtask(null)
        queryClient.invalidateQueries()
      },
      onError: (error: any) => {
        Toast.fire({
          icon: 'error',
          title: error?.response?.data?.message || 'Erro ao vincular subtarefa.',
          customClass: {
            popup: 'bg-light-danger',
            title: 'text-danger',
          },
        })
      },
    }
  )

  const removeSubtask = useMutation(
    (subtaskTemplateId: number) => removeSubtaskTemplate(task.id as number, subtaskTemplateId),
    {
      onSuccess: () => {
        Toast.fire({
          icon: 'success',
          title: 'Subtarefa removida com sucesso!',
          customClass: {
            popup: 'bg-light-success',
            title: 'text-success',
          },
        })
        queryClient.invalidateQueries()
      },
      onError: (error: any) => {
        Toast.fire({
          icon: 'error',
          title: error?.response?.data?.message || 'Erro ao remover subtarefa.',
          customClass: {
            popup: 'bg-light-danger',
            title: 'text-danger',
          },
        })
      },
    }
  )

  const loadAssignableSubtaskOptions = async (inputValue: string): Promise<SubtaskSelectOption[]> => {
    const templates = await getAssignableSubtaskTemplates({
      search: inputValue,
      limit: SUBTASK_OPTIONS_LIMIT,
      excludeTemplateId: task?.id,
    })

    return templates.map((template) => ({
      value: Number(template.id),
      label: template.name || '',
      priority: template.priority ?? null,
    }))
  }

  const initialValues = {
    id: task.id,
    file: [],
    name: task.name || '',
    description: task.description || '',
    begin_date: task.begin_date || '',
    expected_date: task.expected_date || '',
    project_id: task.project_id,
    checklist_concluded: [],
    checklist_name: [],
    users: [],
    tags: [],
    sequence_responsibles: [],
    usersAll: [],
    priority: task.priority || '',
  }

  const priorityOptions = taskPriorityOptions

  const formik = useFormik({
    initialValues: initialValues,
    onSubmit: async (values, {setSubmitting}) => {
      setSubmitting(true)
      try {
        await updateTaskTemplate(values).then((response) => {
          Toast.fire({
            icon: 'success',
            title: intl.formatMessage(
              {id: 'ALERT.LABEL.SUCCESS_TASK_UPDATE_ITEM'},
              {item: intl.formatMessage({id: 'TABLE.GENERAL.LABEL.TASK'})}
            ),
            customClass: {
              popup: 'bg-light-success',
              title: 'text-success',
            },
          })
          queryClient.invalidateQueries()
          searchParams.delete('taskTemplateId')
          handleClose()
        })
      } catch (ex) {
        console.error(ex)
      } finally {
        setSubmitting(true)
        queryClient.invalidateQueries()
      }
    },
  })

  const submitForm = useCallback(
    async (e: any) => {
      formik.setFieldValue('tags', selectedOptions)

      const checksConcluded = checks.map((check) => Boolean(check.check))
      const checksNames = checks.map((check) => check.content || '')

      formik.setFieldValue('checklist_concluded', checksConcluded)
      formik.setFieldValue('checklist_name', checksNames)

      formik.submitForm()
    },
    [formik]
  )

  const CustomToggle = forwardRef((props: CustomToggleProps, ref: React.Ref<HTMLAnchorElement>) => (
    <a
      href=''
      className='text-hover-primary'
      ref={ref}
      onClick={(e) => {
        e.preventDefault()
        props.onClick(e)
      }}
    >
      {props.children}
      <span style={{paddingLeft: '5px'}}></span>
    </a>
  ))

  return (
    <div className='modal-content task-modal-content min-h-650px'>
      <div id='kt_modal_add_project_milestone_form' className='form'>
        <div className='modal-header border-0 flex-wrap'>
          <div className='col-9 col-md-6'>
            <input
              value={formik.values.name ?? ''}
              onChange={(e: any) => formik.setFieldValue('name', e.target.value)}
              placeholder={intl.formatMessage({id: 'FORM.INPUT.NAME.TASK_TITLE'})}
              type='text'
              name='name'
              onKeyPress={(e) => {
                e.key === 'Enter' && e.preventDefault()
              }}
              className={clsx('form-control py-2 bg-transparent border-0 fs-1')}
              autoComplete='off'
            />
          </div>

          {!!task && (
            <div className='col-12 col-md-2 order-last order-md-0 d-flex justify-content-start justify-content-md-end pe-4 mt-3 mt-md-0'>
              <UsersSymbolGroupColumn
                users={
                  formik.values.sequence_responsibles.length > 0
                    ? formik.values.sequence_responsibles
                    : task.users!
                }
                usersAll={task.usersAll}
                taskId={task.id}
                isReadonly={formik.values.sequence_responsibles.length > 0}
                isTemplate={true}
              />
            </div>
          )}

          <div className='col-3 col-md-1 d-flex justify-content-end align-items-center'>
            <div className='actions pt-1'>
              <Dropdown>
                <Dropdown.Toggle as={CustomToggle} id='dropdown-custom-components'>
                  <i className='bi bi-list-ul fs-1 text-dark'></i>
                </Dropdown.Toggle>
                <Dropdown.Menu>
                  <Dropdown.Item onClick={deleta} eventKey='3'>
                    {intl.formatMessage({id: 'TABLE.GENERAL.LABEL.DELETE'})}
                  </Dropdown.Item>
                </Dropdown.Menu>
              </Dropdown>
              {/* end::Menu */}
            </div>
            <button
              className='btn btn-sm btn-icon btn-active-color-primary h-auto ms-4'
              onClick={(e) => {
                if (e.detail === 0) return
                handleClose()
              }}
            >
              <KTSVG
                className='svg-icon-2x svg-icon-gray-800'
                path='/media/icons/duotune/arrows/arr061.svg'
              />
            </button>
          </div>
        </div>
        <div className='modal-body d-flex flex-column flex-lg-row justify-content-between'>
          <div className='col-lg-8 pe-md-5 pb-5 pb-lg-0 mb-15 mb-lg-0 border-bottom border-bottom-lg-0 d-flex flex-column'>
            <ul
              className='nav nav-stretch nav-line-tabs fw-bold border-transparent flex-nowrap '
              role='tablist'
            >
              <li className='nav-item'>
                <a
                  className='nav-link cursor-pointer text-gray-900 active'
                  data-bs-toggle='tab'
                  href='#kt_task_description_pane'
                >
                  {intl.formatMessage({id: 'TASK.TABLE.DESCRIPTION'})}
                </a>
              </li>
              <li className='nav-item'>
                <a
                  className='nav-link cursor-pointer text-gray-900'
                  data-bs-toggle='tab'
                  href='#kt_task_attachments_pane'
                >
                  {intl.formatMessage({id: 'TASK.TABLE.ATTACHMENTS'})}
                </a>
              </li>
              <li className='nav-item'>
                <a
                  className='nav-link cursor-pointer text-gray-900'
                  data-bs-toggle='tab'
                  href='#kt_task_checklist_pane'
                >
                  {intl.formatMessage({id: 'TASK.TABLE.CHECKLIST'})}
                </a>
              </li>
              <li className='nav-item'>
                <a
                  className='nav-link cursor-pointer text-gray-900 d-flex align-items-center'
                  data-bs-toggle='tab'
                  href='#kt_task_subtasks_pane'
                >
                  <span>{intl.formatMessage({id: 'TASK.TABLE.SUBTASKS'})}</span>
                  <span className='badge badge-light-primary ms-2'>
                    {(task?.subtasks || []).length}
                  </span>
                </a>
              </li>
              {/* <li className='nav-item align-items-center align-items-center'>
                    <a
                      className='nav-link cursor-pointer text-gray-900'
                      data-bs-toggle='tab'
                      href='#kt_task_responsible_sequence_pane'
                    >
                      {intl.formatMessage({id: 'TASK.TABLE.RESPONSIBLE_SEQUENCE'})}
                    </a>
                    <OverlayTrigger
                      placement='top'
                      delay={{show: 50, hide: 100}}
                      overlay={
                        <Tooltip>
                          Crie uma sequência de responsáveis e organize a passagem de bastão da
                          tarefa. Assim, ao entregar uma parte, a tarefa será transferida de forma
                          automática para o próximo usuário.
                        </Tooltip>
                      }
                    >
                      <i className='fas fa-exclamation-circle ms-2 fs-7' />
                    </OverlayTrigger>
                  </li> */}
            </ul>
            <div
              className='tab-content pt-3 overflow-y-scroll min-h-500px'
              style={{maxHeight: '60vh'}}
            >
              <div
                id='kt_task_description_pane'
                className='task-ckeditor-container tab-pane fade show active'
              >
                <CKEditor
                  // @ts-ignore
                  editor={SourceEditingEditor}
                  disabled={formik.isSubmitting}
                  id='description'
                  onChange={(event: any, editor: any) =>
                    formik.setFieldValue('description', editor.getData())
                  }
                  config={{
                    toolbar: [
                      'undo',
                      'redo',
                      '|',
                      'heading',
                      '|',
                      'bold',
                      'italic',
                      '|',
                      'link',
                      'blockQuote',
                      '|',
                      'bulletedList',
                      'numberedList',
                      '|',
                      'uploadImage',
                    ],
                    simpleUpload: {
                      uploadUrl: `${process.env.REACT_APP_THEME_API_URL || process.env.REACT_APP_API_URL || ''}/api/upload`,
                      headers: {
                        Authorization: 'Bearer ' + auth?.api_token,
                      },
                    },
                    initialData: formik.getFieldProps('description').value,
                  } as any}
                />
              </div>

              <div id='kt_task_attachments_pane' className='tab-pane fade'>
                <div className='pt-6'>
                  <Attachement templateId={task.id} attachments={task.attachments} />
                </div>
              </div>

              <div id='kt_task_checklist_pane' className='tab-pane fade'>
                <TaskChecklistEditor
                  items={checks}
                  onChange={setChecks}
                  disabled={formik.isSubmitting}
                />
              </div>

              <div id='kt_task_subtasks_pane' className='tab-pane fade'>
                <div className='pt-6 subtasks-container'>
                  <p className='text-muted fs-7 mb-4'>
                    Somente modelos sem pai e sem subtarefas aparecem na lista.
                  </p>
                  <div className='d-flex align-items-center gap-3 w-100 flex-nowrap'>
                    <div className='flex-grow-1 min-w-0'>
                      <AsyncSelect<SubtaskSelectOption, false>
                        value={selectedSubtask}
                        defaultOptions
                        cacheOptions
                        loadOptions={loadAssignableSubtaskOptions}
                        onChange={(option) => setSelectedSubtask(option)}
                        isDisabled={addSubtask.isLoading}
                        placeholder='Digite para buscar modelos de tarefa'
                        noOptionsMessage={() => 'Nenhum modelo encontrado'}
                        loadingMessage={() => 'Buscando...'}
                        menuPortalTarget={document.body}
                        menuPosition='fixed'
                        styles={{
                          menuPortal: (base) => ({...base, zIndex: 9999}),
                          control: (styles) => ({
                            ...styles,
                            minHeight: '35px',
                            border: '0',
                            backgroundColor: 'var(--bs-gray-100)',
                          }),
                          menu: (styles) => ({
                            ...styles,
                            backgroundColor: 'var(--bs-body-bg)',
                            color: 'var(--bs-body-color)',
                          }),
                          option: (styles, {isFocused, isSelected}) => ({
                            ...styles,
                            backgroundColor: isSelected
                              ? 'rgba(54, 155, 255, 0.35)'
                              : isFocused
                                ? 'rgba(54, 155, 255, 0.2)'
                                : 'transparent',
                            color: 'var(--bs-body-color)',
                          }),
                          valueContainer: (styles) => ({
                            ...styles,
                            padding: '2px 8px',
                          }),
                          input: (styles) => ({
                            ...styles,
                            color: 'var(--bs-body-color)',
                          }),
                          singleValue: (styles) => ({
                            ...styles,
                            color: 'var(--bs-body-color)',
                          }),
                          placeholder: (styles) => ({
                            ...styles,
                            color: 'var(--bs-gray-600)',
                          }),
                        }}
                        classNames={{
                          control: () =>
                            'form-control form-control-sm border-0 rounded bg-gray-100 bg-focus-gray-100 py-2',
                          menu: () => 'bg-body',
                        }}
                      />
                    </div>
                    <button
                      type='button'
                      className='btn btn-primary btn-sm flex-shrink-0'
                      disabled={!selectedSubtask || addSubtask.isLoading}
                      onClick={() => {
                        if (!selectedSubtask) {
                          return
                        }
                        addSubtask.mutate(Number(selectedSubtask.value))
                      }}
                      style={{whiteSpace: 'nowrap'}}
                    >
                      <i className='bi bi-plus-lg me-1'></i>
                      Vincular
                    </button>
                  </div>

                  <div className='checklist pt-6'>
                    <div className='checklist-items'>
                      {(task?.subtasks || []).length === 0 ? (
                        <div className='text-muted fs-7 py-6 ps-1'>
                          Nenhuma subtarefa vinculada. Use o seletor acima para incluir um modelo
                          existente.
                        </div>
                      ) : (
                        (task?.subtasks || []).map((subtask) => (
                          <div
                            key={subtask.id}
                            className='check d-flex align-items-center py-2'
                            style={{paddingLeft: '40px'}}
                          >
                            <div className='flex-grow-1 d-flex align-items-center min-w-0'>
                              <span
                                className='me-2 text-muted flex-shrink-0'
                                style={{fontSize: '0.875rem'}}
                              >
                                <i className='bi bi-arrow-return-right'></i>
                              </span>
                              <span
                                className='form-control border-0 bg-transparent p-0 text-truncate'
                                style={{flex: 1, boxShadow: 'none'}}
                              >
                                {subtask.name}
                              </span>
                              {subtask.priority ? (
                                <span className='badge badge-light-secondary ms-2 flex-shrink-0'>
                                  {subtask.priority}
                                </span>
                              ) : null}
                            </div>
                            <button
                              type='button'
                              className='btn btn-icon btn-sm btn-active-light-danger ms-2 flex-shrink-0'
                              title='Remover'
                              onClick={() => removeSubtask.mutate(Number(subtask.id))}
                              disabled={removeSubtask.isLoading}
                            >
                              <i className='bi bi-trash3-fill text-danger'></i>
                            </button>
                          </div>
                        ))
                      )}
                    </div>
                  </div>
                </div>
              </div>

              {/* {!!task && (
                    <TaskSequenceResponsibles
                      formikSetFieldValue={formik.setFieldValue}
                      users={task.usersAll}
                      responsibles={formik.values.sequence_responsibles}
                      isCreate={true}
                    />
                  )} */}
            </div>
          </div>
          <div className='col-lg-4 d-flex flex-column border-start-lg ps-lg-10 min-h-450px'>
            <div className='border-bottom pb-8'>
              <div className='d-flex mb-4'>
                <span className='fw-bold text-dark me-1'>
                  {intl.formatMessage({id: 'TASK.LABEL.TASK_ID'})} {task.id}
                </span>
              </div>

              <div className='d-flex mb-4'>
                <span className='fw-bold text-dark me-1'>
                  {intl.formatMessage({id: 'TASK.LABEL.CREATOR_DEADLINE'})} {task?.creator?.name}
                </span>
              </div>

              {/* <div className='d-flex mb-4'>
                    <span className='fw-bold text-dark me-1'>
                      {intl.formatMessage({id: 'FORM.INPUT.NAME.CREATED_AT'})} {task.created_at}
                    </span>
                  </div> */}
            </div>

            <div className='pt-10'>
              <div>
                <label className='fw-bold text-dark me-1'>Prioridade:</label>
                <CreatableSelect
                  isClearable
                  placeholder={'Selecione a prioridade'}
                  options={[
                    {label: 'Baixa', value: 'baixa'},
                    {label: 'Média', value: 'media'},
                    {label: 'Alta', value: 'alta'},
                    {label: 'Crítica', value: 'critica'},
                  ]}
                  value={priorityOptions.find(
                    (priority) => priority.value == formik.values.priority
                  )}
                  onChange={(newValue) => formik.setFieldValue('priority', newValue?.value)}
                  classNames={{
                    control: (state) => 'form-control form-control-solid py-1',
                    input: (state) => 'text-dark',
                    singleValue: (state) => 'text-dark',
                    menu: (state) => 'bg-body',
                  }}
                  isSearchable={false}
                  styles={{
                    option: (styles, {data, isDisabled, isFocused, isSelected}) => {
                      return {
                        ...styles,
                        backgroundColor: isDisabled
                          ? undefined
                          : isSelected
                          ? '#b5d44e70'
                          : isFocused
                          ? '#b5d44e70'
                          : undefined,
                        color: isDisabled ? '#ccc' : isSelected ? '#181C32' : undefined,
                      }
                    },
                    clearIndicator(styles, props) {
                      return {
                        ...styles,
                        cursor: 'pointer',
                      }
                    },
                  }}
                />
              </div>
            </div>

            {!!selectedOptions && (
              <div className='pt-4'>
                <div>
                  <label className='fw-bold text-dark me-1'>Tags:</label>
                  <TagsAutoComplete
                    selectedOptions={selectedOptions}
                    setSelectedOptions={setSelectedOptions}
                  />
                </div>
              </div>
            )}

            <div className='text-center mt-auto'>
              <button
                type='button'
                className='btn btn-primary btn-sm px-8 mt-auto'
                data-kt-users-modal-action='submit'
                onClick={submitForm}
                disabled={formik.isSubmitting || !formik.isValid || !formik.touched}
              >
                <span className='indicator-label'>
                  {intl.formatMessage({id: 'GENERAL.EDIT_TASK'})}
                </span>

                {formik.isSubmitting && (
                  <span className='indicator-progress'>
                    <span className='spinner-border spinner-border-sm align-middle ms-2'></span>
                  </span>
                )}
              </button>
            </div>
          </div>
        </div>
      </div>
      {formik.isSubmitting && <Loading />}
    </div>
  )
}
